type InputErrorTextProps = {
  children: string
}

export const InputErrorText = ({ children }: InputErrorTextProps) => (
  <p className='font-medium text-sm mt-1 text-red-500 px-5'>{children}</p>
)
